import { forwardRef } from 'react';

export const SquareMeterIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 37C11.4477 37 11 36.5203 11 35.9286L11 8.07143L13 8.07143L13 35.9286C13 36.5203 12.5523 37 12 37Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7072 7.31381C13.0977 7.73223 13.0977 8.41062 12.7072 8.82904L8.70714 13.1148C8.31661 13.5332 7.68343 13.5332 7.2929 13.1148C6.90237 12.6963 6.90237 12.0179 7.2929 11.5995L11.293 7.31381C11.6835 6.8954 12.3167 6.8954 12.7072 7.31381Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.293 7.31381C10.9024 7.73223 10.9023 8.41062 11.2928 8.82904L15.2929 13.1148C15.6834 13.5332 16.3166 13.5332 16.7071 13.1148C17.0976 12.6963 17.0976 12.0179 16.7071 11.5995L12.7072 7.31381C12.3167 6.8954 11.6835 6.8954 11.293 7.31381Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 36C11 35.4477 11.4797 35 12.0714 35L39.9286 35L39.9286 37L12.0714 37C11.4797 37 11 36.5523 11 36Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.6862 36.7072C40.2678 37.0977 39.5894 37.0977 39.171 36.7072L34.8852 32.7071C34.4668 32.3166 34.4668 31.6834 34.8852 31.2929C35.3037 30.9024 35.9821 30.9024 36.4005 31.2929L40.6862 35.293C41.1046 35.6835 41.1046 36.3167 40.6862 36.7072Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.6862 35.293C40.2678 34.9024 39.5894 34.9023 39.171 35.2928L34.8852 39.2929C34.4668 39.6834 34.4668 40.3166 34.8852 40.7071C35.3037 41.0976 35.9821 41.0976 36.4005 40.7071L40.6862 36.7072C41.1046 36.3167 41.1046 35.6835 40.6862 35.293Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8C15 7.44772 15.4477 7 16 7H40C40.5523 7 41 7.44772 41 8C41 8.55228 40.5523 9 40 9H16C15.4477 9 15 8.55228 15 8Z"
          fill="#004B54"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 33C39.4477 33 39 32.5523 39 32V8C39 7.44772 39.4477 7 40 7C40.5523 7 41 7.44772 41 8V32C41 32.5523 40.5523 33 40 33Z"
          fill="#004B54"
        />
        <path
          d="M19.6364 25.9999C19.2845 25.9999 19 25.7261 19 25.3874V21.5612C19 21.2225 19.2845 20.9487 19.6364 20.9487C19.9882 20.9487 20.2727 21.2225 20.2727 21.5612V25.3874C20.2727 25.7261 19.9882 25.9999 19.6364 25.9999Z"
          fill="#004B54"
        />
        <path
          d="M23.6193 22.1737C23.2674 22.1737 22.9829 21.8998 22.9829 21.5612C22.9829 20.8406 22.3765 20.2569 21.6278 20.2569C20.8791 20.2569 20.2727 20.8406 20.2727 21.5612C20.2727 21.8998 19.9882 22.1737 19.6364 22.1737C19.2845 22.1737 19 21.8998 19 21.5612C19 20.1633 20.1754 19.032 21.6278 19.032C23.0802 19.032 24.2556 20.1633 24.2556 21.5612C24.2556 21.8998 23.9711 22.1737 23.6193 22.1737Z"
          fill="#004B54"
        />
        <path
          d="M27.6097 22.1737C27.2579 22.1737 26.9734 21.8998 26.9734 21.5612C26.9734 20.8406 26.3669 20.2569 25.6183 20.2569C24.8696 20.2569 24.2632 20.8406 24.2632 21.5612C24.2632 21.8998 23.9787 22.1737 23.6268 22.1737C23.275 22.1737 22.9905 21.8998 22.9905 21.5612C22.9905 20.1633 24.1659 19.032 25.6183 19.032C27.0707 19.032 28.2461 20.1633 28.2461 21.5612C28.2461 21.8998 27.9616 22.1737 27.6097 22.1737Z"
          fill="#004B54"
        />
        <path
          d="M27.6095 25.9999C27.2576 25.9999 26.9731 25.7261 26.9731 25.3874V21.5612C26.9731 21.2225 27.2576 20.9487 27.6095 20.9487C27.9614 20.9487 28.2459 21.2225 28.2459 21.5612V25.3874C28.2459 25.7261 27.9614 25.9999 27.6095 25.9999Z"
          fill="#004B54"
        />
        <path
          d="M23.619 25.9999C23.2672 25.9999 22.9827 25.7261 22.9827 25.3874V21.5612C22.9827 21.2225 23.2672 20.9487 23.619 20.9487C23.9709 20.9487 24.2554 21.2225 24.2554 21.5612V25.3874C24.2554 25.7261 23.9709 25.9999 23.619 25.9999Z"
          fill="#004B54"
        />
        <path
          d="M32.3635 21.9432H29.6832C29.3314 21.9432 29.0469 21.6694 29.0469 21.3307C29.0469 20.9921 29.3314 20.7183 29.6832 20.7183H32.3635C32.7153 20.7183 32.9998 20.9921 32.9998 21.3307C32.9998 21.6694 32.7153 21.9432 32.3635 21.9432Z"
          fill="#004B54"
        />
        <path
          d="M29.6832 21.943C29.5035 21.943 29.3238 21.871 29.204 21.7341C28.9719 21.4747 29.0019 21.0928 29.2714 20.8694L30.9634 19.4643C31.2254 19.2409 31.6297 19.2697 31.8618 19.5291C32.0939 19.7885 32.0639 20.1704 31.7944 20.3938L30.1024 21.7989C29.9826 21.8998 29.8329 21.9502 29.6832 21.9502V21.943Z"
          fill="#004B54"
        />
        <path
          d="M31.2927 20.6028C31.1205 20.6028 30.9558 20.538 30.8285 20.4083C30.589 20.1633 30.6039 19.7742 30.8585 19.5436L31.1355 19.2986C31.3301 19.1041 31.4349 18.9888 31.4349 18.7798C31.4349 18.4123 31.2403 18.225 30.8585 18.225C30.5365 18.225 30.282 18.4772 30.282 18.7798C30.282 19.1185 29.9975 19.3923 29.6456 19.3923C29.2938 19.3923 29.0093 19.1185 29.0093 18.7798C29.0093 17.7998 29.8403 17 30.8585 17C31.9515 17 32.7077 17.735 32.7077 18.7798C32.7077 19.486 32.2884 19.9111 32.0563 20.1417L31.7344 20.4371C31.6146 20.5452 31.4574 20.6028 31.3002 20.6028H31.2927Z"
          fill="#004B54"
        />
      </svg>
    );
  },
);
